
export const getSocket = (taskData, socketId) => {
    return taskData.sockets.find(socket => socket.id === socketId)
}

export const updateSocket = (taskData, socketId, updatedSocket) => {
    taskData.sockets = taskData.sockets.map(socket => {
        if (socket.id === socketId) {
            return updatedSocket
        }
        return socket
    })
    return taskData
}